import { useObserver } from 'mobx-react';
import { Route, withRouter, useLocation } from "react-router-dom";
import { useEffect, useRef, Fragment } from 'react';
import vm from './TimelineVm';
import st from './Timeline.module.scss';
import clsx from 'clsx';
import queryString from 'query-string';
import portalModel from '@model/portalModel';

function Timeline() {
    let location = useLocation();
    const customerId = queryString.parse(location.search).customerId;
    useEffect(() => {
        vm.getTimeline(customerId);
    }, [])
    const textarea = useRef();
    return useObserver(() => (
        <div className={st.timeline}>
            <form className={st.submitText} onSubmit={(e) => vm.submit(e, customerId, textarea)}>
                <textarea type="text" className={st.inputText} rows={1} placeholder="메모입력" name="message" value={vm.state.message} ref={textarea} onChange={(e) => vm.message(e, textarea)}/>
                <button type='submit' className={st.submit}/>
            </form>
            <div className={st.content}>
                <ul className={st.tab}>
                    <li className={vm.state.activeTab === null ? st.active : null}><button type="button" onClick={() => vm.changeTab(customerId, null)}>전체</button></li>
                    <li className={vm.state.activeTab === "MEMO" ? st.active : null}><button type="button" onClick={() => vm.changeTab(customerId, "MEMO")}>메모</button></li>
                    <li className={vm.state.activeTab === "PROGRESS" ? st.active : null}><button type="button" onClick={() => vm.changeTab(customerId, "PROGRESS")}>수임동의</button></li>
                    <li className={vm.state.activeTab === "ALIMTALK" ? st.active : null}><button type="button" onClick={() => vm.changeTab(customerId, "ALIMTALK")}>알림톡&이메일</button></li>
                </ul>
                <div className={st.list}>
                    {vm.pinnedTimeLines.length !== 0 && 
                        <>
                            <div className={st.pinListTitle}>
                                <input type="checkbox" checked={vm.state.pinned} onChange={(e) => vm.state.pinned = !vm.state.pinned} id="pinned" className={st.radioCheckInput}/><label htmlFor="pinned" className={st.radioCheckLabel}></label>
                                <span className={st.pinLengthText}>{vm.pinnedTimeLines.length} 고정됨</span>
                            </div>
                            {vm.state.pinned === true && 
                                <ul className={st.pinList}>
                                    {vm.pinnedTimeLines.map((pinnedTimeLine, index) => (
                                        <li key={index}>
                                            <span className={st.date}>{pinnedTimeLine.createdAt}</span>
                                            {(pinnedTimeLine.automaticYn !== true && pinnedTimeLine.creator) && 
                                                <span className={st.name}>{pinnedTimeLine.creatorType === "CUSTOMER" ? `고객(${pinnedTimeLine.creator})`: pinnedTimeLine.creator}</span>
                                            }
                                            <span className={
                                                clsx(
                                                    st.memo, 
                                                    pinnedTimeLine.message.includes('!!!') ? st.important : null,
                                                    (pinnedTimeLine.timelineType === "PROGRESS" && pinnedTimeLine.creatorType === "CUSTOMER") ? st.auto_customer : null,
                                                    (pinnedTimeLine.timelineType === "PROGRESS" && pinnedTimeLine.creatorType === "ACCOUNTING_FIRM") ? st.auto_accounting : null,
                                                    pinnedTimeLine.timelineType === "ALIMTALK" ? st.sendTalk : null
                                                )}>
                                                {pinnedTimeLine.message}
                                            </span>
                                            <div className={st.btnGroup}>
                                                <button type="button" className={st.pin} onClick={() => vm.pin(customerId, pinnedTimeLine.id, false)}/>
                                                <button type="button" className={st.delete} onClick={() => vm.delete(customerId, pinnedTimeLine.id)}/>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            }
                        </>
                    }
                    {vm.normalTimeLines.length === 0 && 
                        <div className={st.empty}>새로운 메모가 없습니다.</div>
                    }
                    <ul className={st.nomalList}>

                    {/* (normalTimeLine.timelineType === "PROGRESS" && normalTimeLine.creatorType === "CUSTOMER") ? st.auto_customer : null,
                    (normalTimeLine.timelineType === "PROGRESS" && normalTimeLine.creatorType === "ACCOUNTING_FIRM") ? st.auto_accounting : null, */}
                        {vm.normalTimeLines.map((normalTimeLine, index) => (
                            <Fragment key={index}>
                                {normalTimeLine.timelineType === "PROGRESS" ? 
                                    <li className={st.progressLine}>
                                        <span className={st.progressContent}>
                                            <span className={st.date}>{normalTimeLine.createdAt}</span>
                                            {normalTimeLine.creator && 
                                                <span className={st.name}>{normalTimeLine.creatorType === "CUSTOMER" ? `고객(${normalTimeLine.creator})`: normalTimeLine.creator}</span>
                                            }
                                            <span className={
                                                clsx(
                                                    st.memo,
                                                    (normalTimeLine.timelineType === "PROGRESS" && normalTimeLine.creatorType === "CUSTOMER") ? st.auto_customer : null,
                                                    (normalTimeLine.timelineType === "PROGRESS" && normalTimeLine.creatorType === "ACCOUNTING_FIRM") ? st.auto_accounting : null,
                                                )}>
                                                {normalTimeLine.message}
                                            </span>
                                        </span>
                                    </li>
                                : 
                                    <li>
                                        <span className={st.date}>{normalTimeLine.createdAt}</span>
                                        {(normalTimeLine.automaticYn !== true && normalTimeLine.creator) && 
                                            <span className={st.name}>{normalTimeLine.creatorType === "CUSTOMER" ? `고객(${normalTimeLine.creator})`: normalTimeLine.creator}</span>
                                        }
                                        <span className={
                                            clsx(
                                                st.memo, 
                                                normalTimeLine.message.includes('!!!') ? st.important : null,
                                                normalTimeLine.timelineType === "ALIMTALK" ? st.sendTalk : null
                                            )}>
                                            {normalTimeLine.message}
                                            {normalTimeLine.pinned === true && 
                                                <button type='button' className={st.pin} onClick={() => vm.pin(customerId, normalTimeLine.id, !normalTimeLine.pinned)}/>
                                            }
                                        </span>
                                        <div className={st.btnGroup}>
                                            <button type="button" className={st.pin} onClick={() => vm.pin(customerId, normalTimeLine.id, !normalTimeLine.pinned)}/>
                                            <button type="button" className={st.delete} onClick={() => vm.delete(customerId, normalTimeLine.id)}/>
                                        </div>
                                    </li>
                                }
                            </Fragment>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    ));
}
export default Timeline;